import { render, staticRenderFns } from "./HeaderOrderComponent.vue?vue&type=template&id=233716ee&"
import script from "./HeaderOrderComponent.vue?vue&type=script&lang=js&"
export * from "./HeaderOrderComponent.vue?vue&type=script&lang=js&"
import style0 from "./HeaderOrderComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports